






















import { Component, Mixins } from "vue-property-decorator";
import {
  DraggableLineDrawableObjectMixin
} from "./mixins";
import RectangleDragHandles from "../../../dragging/RectangleDragHandles.vue";
import { IKeyboardEventHandleable } from "..";
import { KeyCodeProcessor } from "./KeyCodeProcessor";

@Component({
  components: {
    RectangleDragHandles,
  },
})
export default class CrossObject extends Mixins(
  DraggableLineDrawableObjectMixin
) implements IKeyboardEventHandleable {
  handleKeyboardEvent(event: KeyboardEvent): boolean {
    if (!this.editingSource.isEditable) {
      return false;
    }
    const moveOffset = KeyCodeProcessor.toMoveOffset(event.keyCode);
    if (moveOffset) {
      this.writeProperty(s => s.geometry.rectangle = s.geometry.rectangle.move(moveOffset));
      return true;
    }
    return false;
  }
}
